import styled from 'styled-components';
import { useContext } from 'react';
import RestaurantContext from '../../Context/RestaurantContext';
import dayjs from 'dayjs';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;

  justify-content: center;

  @media (min-width: 576px) {
    align-items: center;
  }

  padding: 20px;

  background-color: RGBA(236, 151, 31, 0.1);

  span {
    display: block;
    margin: 0;
    color: #ec971f;
    font-size: 15px;
    letter-spacing: 0.67px;
    font-weight: 500;
  }
  p {
    margin: 0;
    color: #ec971f;
    font-size: 19px;
    letter-spacing: 0.84px;
    font-weight: 700;
  }
`;

const StoreStatusComponent = (props) => {
  const { restaurantProps: storeProps, getOverallStatus } = useContext(RestaurantContext);

  const getRestaurantStatusText = ({ payload }) => {
    let heading = '';
    let subtitle = '';
    switch (getOverallStatus(storeProps)) {
      case 'CLOSED':
        heading = 'Restaurant aktuell geschlossen';
        subtitle = 'Besuchen Sie uns gerne wieder zu unseren Öffnungszeiten';
        break;
      case 'WILL_OPEN':
        heading = 'Restaurant noch geschlossen';
        subtitle = `Wir öffnen um ${dayjs(payload.firstMoment)
          .locale('de')
          .format('HH:mm')} Uhr. Vorbestellungen möglich.`;
        break;
      case 'INACTIVE':
        heading = 'Lieferdienst kurzzeitig deaktiviert';
        subtitle = 'Bitte versuchen Sie es später noch einmal';
        break;
      case 'HOLIDAYS':
        heading = 'Wir sind aktuell im Urlaub';
        const holidayTo = dayjs(payload.dateTo).add(1, 'day').locale('de').format('DD.MM.YYYY');
        subtitle = `Ab dem ${holidayTo} sind wir wieder zurück`;
        break;
      case 'OFFLINE':
        heading = 'Restaurant aktuell offline';
        subtitle = 'Bitte versuchen Sie es später noch einmal';
        break;
    }

    return (
      <>
        <p>{heading}</p>
        <span>{subtitle}</span>
      </>
    );
  };

  return (
    getOverallStatus(storeProps) !== 'OPENED' && (
      <Wrapper>{getRestaurantStatusText(storeProps.statusData)}</Wrapper>
    )
  );
};

export default StoreStatusComponent;
